import {FC} from 'react'

type Props = {
  date?: string
}

const DateCell: FC<Props> = ({date}) => (
  <div className='text-gray-600 fw-bold'>{date || '-'}</div>
)

export {DateCell}

